class Normalizer {
  static extractDigits = value => value.replace(/[^\d]/g, '');

  static extractAllButSpaces = value => value.replace(/\s/g, '');

  static nomralizeExt = input => parseInt(Normalizer.extractDigits(input), 10);

  static normalizePhoneOrFax = input =>
    parseInt(Normalizer.extractDigits(input).slice(0, 10), 10);

  static normalizeZip = input =>
    parseInt(Normalizer.extractDigits(input).slice(0, 5), 10);

  static normalizeFeinOrSsn = input =>
    parseInt(Normalizer.extractDigits(input).slice(0, 9), 10);

  static normalizeMoney = input => parseInt(this.extractDigits(input), 10);

  static normalizePersents = input =>
    parseInt(Normalizer.extractDigits(input).slice(0, 3), 10);
}

export default Normalizer;
